import clsx from "clsx";
import type { ReactNode } from "react";

/** Sidebar item (admin-design.md §4.1): navy ground, brick "you are here" marker. */
export function NavItem({ icon, label, active, onClick, badge }: { icon: ReactNode; label: string; active: boolean; onClick: () => void; badge?: number }) {
  return (
    <li
      onClick={onClick}
      style={{ listStyle: "none" }}
      className={clsx(
        "relative flex items-center gap-3 px-4 py-2.5 mb-1 rounded-md text-[13px] font-grotesk font-medium cursor-pointer transition-colors duration-150",
        active ? "text-white bg-navy-800" : "text-navy-200 hover:text-white hover:bg-navy-800",
      )}
    >
      {active && <span className="absolute left-0 top-1.5 bottom-1.5 w-0.5 bg-brick rounded-full" />}
      <span className="flex h-5 w-5 items-center justify-center">{icon}</span>
      <span className="flex-1">{label}</span>
      {badge ? <span className="rounded-md bg-brick px-1.5 text-[11px] font-semibold text-white tnum">{badge}</span> : null}
    </li>
  );
}
